import React, { useState } from "react";
import {
  Dialog,
  Button,
  CircularProgress,
  Box,
  Input,
  Typography,
  DialogContent,
} from "@mui/material";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import { useMaterialUIController } from "context";
import MDButton from "components/MDButton";

const BackupUpload = ({ open, onClose, onUploadFile, loading }) => {
  const [file, setFile] = useState(null);
  const [controller] = useMaterialUIController();
  const { activePage, darkMode } = controller;
  const handleFileSelect = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={(theme) => CTLDialogContent(theme, { darkMode })}
    >
      <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
          Upload Backup File
        </Typography>
        <Input
          type="file"
          onChange={handleFileSelect}
          disabled={loading}
          sx={{ mb: 2 }}
          inputProps={{ accept: ".zip,.tar,.gz,.sql" }}
        />
        <Box sx={{ mt: 3, display: "flex", gap: 1.5 }}>
          <MDButton
            variant="contained"
            color="secondary"
            onClick={onClose}
            disabled={loading}
            sx={{ minWidth: 100 }}
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            onClick={() => onUploadFile(file)}
            disabled={!file || loading}
            sx={{ minWidth: 100 }}
          >
            {loading ? <CircularProgress size={24} /> : "Upload"}
          </MDButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BackupUpload;
